
function Empty() {

    return (<></>)
}

export default Empty